<h2>MY PROFILE</h2>
<div class="manage-profile__container">
  <div>
    <div>
      <p>
        Registered email: <strong>{{ user.username }}</strong>
      </p>
    </div>

    @if (user.isSuperUser) {
      <div>
        <p>You are logged in as an <strong>Administrator Account</strong></p>
      </div>
    } @else {
      <div>
        <p>Associated Accounts:</p>
        <table mat-table [dataSource]="tableData" class="contrast-table">
          <!--Account Code-->
          <ng-container matColumnDef="accountCode">
            <th mat-header-cell *matHeaderCellDef class="mat-column-center">Account Code</th>
            <td mat-cell *matCellDef="let element" class="mat-column-center">
              <b> {{ element.accountCode }} </b>
            </td>
          </ng-container>

          <!--Account Name-->
          <ng-container matColumnDef="accountName">
            <th mat-header-cell *matHeaderCellDef class="mat-column-center">Name</th>
            <td mat-cell *matCellDef="let element" class="mat-column-center">
              <b> {{ element.accountName }} </b>
            </td>
          </ng-container>

          <!--provider type-->
          <ng-container matColumnDef="providerType">
            <th mat-header-cell *matHeaderCellDef class="mat-column-center">Type</th>
            <td mat-cell *matCellDef="let element" class="mat-column-center">
              <b> {{ element.providerTypeString }} </b>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
          <tr *matNoDataRow>
            <td colspan="100%">
              <div>There are no accounts associated with this login.</div>
            </td>
          </tr>
        </table>
      </div>
    }
  </div>
  <div>
    <p>Click button if you want to reset your password</p>
    <button mat-raised-button (click)="resetPassword()">Reset password</button>
  </div>
  <div>
    <p>Click button if you want to reset your Multi-factor authentication. You will be provided with a new QR code on your next login.</p>
    <button mat-raised-button (click)="resetMfa()">Reset MFA</button>
  </div>
  @if (showRegisterAccount) {
    <div>
      <p>
        Click button to register a new Radio or Premium Rate Service account.<br />
        New accounts need to be checked and approved by ComReg, you will be notified once the account is active.
      </p>
      <button mat-raised-button (click)="registerAccount()">Register Account</button>
    </div>
  }

  @if (!hasAssociatedAccounts) {
    <div>
      <p>Click button to logout</p>
      <button mat-raised-button (click)="logOut()">Log Out</button>
    </div>
  }

  @if (pendingAccountRequests) {
    <div>
      <p>Pending Account Requests:</p>
      <table mat-table [dataSource]="tableDataAccountRequests" class="contrast-table">
        <!--Account Name-->
        <ng-container matColumnDef="accountName">
          <th mat-header-cell *matHeaderCellDef class="mat-column-center">Name</th>
          <td mat-cell *matCellDef="let element" class="mat-column-center">
            <b> {{ element.accountName }} </b>
          </td>
        </ng-container>

        <!--provider type-->
        <ng-container matColumnDef="providerType">
          <th mat-header-cell *matHeaderCellDef class="mat-column-center">Type</th>
          <td mat-cell *matCellDef="let element" class="mat-column-center">
            <b> {{ element.providerType }} </b>
          </td>
        </ng-container>

        <!--Submission Date-->
        <ng-container matColumnDef="submissionDate">
          <th mat-header-cell *matHeaderCellDef class="mat-column-center">Submission Date</th>
          <td mat-cell *matCellDef="let element" class="mat-column-center">
            <b> {{ element.submissionDate | date: 'dd/MM/yyyy' }} </b>
          </td>
        </ng-container>

        <!--status-->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="mat-column-center">Status</th>
          <td mat-cell *matCellDef="let element" class="mat-column-center">
            <b> {{ element.status }} </b>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumnsAccountRequests"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumnsAccountRequests"></tr>
      </table>
    </div>
  }
</div>
